var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "booking-details-landlord__documents-row" }, [
    _c(
      "span",
      { staticClass: "booking-details-landlord__checkbox-label line-clamp-1" },
      [_vm._v(_vm._s(_vm.document.name))]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "booking-details-landlord__documents-actions" }, [
      _vm.document.document_url.slice(-3).toLowerCase() === "pdf" ||
      _vm.document.pdf == 1
        ? _c(
            "a",
            {
              staticClass:
                "theme-btn theme-btn--small theme-btn--tertiary inline-flex gap-0 lg:gap-2",
              attrs: {
                "data-rel":
                  "lightcase:myCollection" + _vm.document.id + "desktop",
                title: _vm.document.name,
                href: _vm.document.document_url
              }
            },
            [
              _c("i", {
                staticClass: "icon-eye",
                staticStyle: { "font-size": "20px" }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "hidden lg:block" }, [
                _vm._v(
                  _vm._s(
                    _vm.locales && _vm.locales.common && _vm.locales.common.view
                  )
                )
              ]),
              _vm._v(" "),
              _c("v-lightcase-holder", {
                attrs: {
                  "current-document": _vm.document,
                  "disable-rotate": true,
                  "image-src": _vm.document.document_url,
                  name: "box-" + _vm.document.id
                }
              })
            ],
            1
          )
        : _c(
            "a",
            {
              staticClass:
                "theme-btn theme-btn--small theme-btn--tertiary inline-flex gap-0 lg:gap-2",
              attrs: {
                href: "#box-" + _vm.document.id,
                "data-rel":
                  "lightcase:myCollection" + _vm.document.id + "desktop"
              }
            },
            [
              _c("i", {
                staticClass: "icon-eye",
                staticStyle: { "font-size": "20px" }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "hidden lg:block" }, [
                _vm._v(
                  _vm._s(
                    _vm.locales && _vm.locales.common && _vm.locales.common.view
                  )
                )
              ]),
              _vm._v(" "),
              _c("v-lightcase-holder", {
                attrs: {
                  "current-document": _vm.document,
                  "disable-rotate": true,
                  "image-src": _vm.document.document_url,
                  name: "box-" + _vm.document.id
                }
              })
            ],
            1
          ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "booking-details-landlord__documents-actions-buttons" },
        [
          _c(
            "button",
            {
              staticClass: "theme-btn theme-btn--small theme-btn--white",
              attrs: { "data-id": _vm.document.id },
              on: {
                click: function($event) {
                  _vm.download($event, "pdf")
                  return false
                }
              }
            },
            [_vm._v("PDF")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "theme-btn theme-btn--small theme-btn--white",
              attrs: { "data-id": _vm.document.id },
              on: {
                click: function($event) {
                  _vm.download($event, "zip")
                  return false
                }
              }
            },
            [_vm._v("ZIP")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass:
                "theme-btn theme-btn--small theme-btn--white hidden md:block",
              attrs: { "data-id": _vm.document.id },
              on: {
                click: function($event) {
                  _vm.print($event)
                  return false
                }
              }
            },
            [_vm._v("PRINT")]
          )
        ]
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal modal--bottom",
        attrs: { "data-feature": "modal", "data-name": "export-file-modal" }
      },
      [
        _c(
          "div",
          {
            staticClass: "modal__content",
            attrs: { "data-feature": "modal-active-area" }
          },
          [
            _vm._m(1),
            _vm._v(" "),
            _c("h3", { staticClass: "section-title-sm mb-2" }, [
              _vm._v("Export file")
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "text-[#7B7C85] mb-4" }, [
              _vm._v(_vm._s(_vm.document.name))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "flex gap-2" }, [
              _c(
                "button",
                {
                  staticClass: "theme-btn theme-btn--white theme-btn--block",
                  on: {
                    click: function($event) {
                      _vm.download($event, "pdf")
                      return false
                    }
                  }
                },
                [_vm._v("PDF")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "theme-btn theme-btn--white theme-btn--block",
                  on: {
                    click: function($event) {
                      _vm.download($event, "zip")
                      return false
                    }
                  }
                },
                [_vm._v("ZIP")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass:
                    "theme-btn theme-btn--small theme-btn--white hidden lg:block",
                  attrs: { "data-id": _vm.document.id },
                  on: {
                    click: function($event) {
                      _vm.print($event)
                      return false
                    }
                  }
                },
                [_vm._v("PRINT")]
              )
            ])
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass:
          "booking-details-landlord__documents-actions-dots theme-btn theme-btn--square--small theme-btn--gray lg:hidden",
        attrs: {
          "data-feature": "open-modal",
          "data-target": "export-file-modal"
        }
      },
      [
        _c("i", {
          staticClass: "icon-dots-horizontal",
          staticStyle: { "font-size": "20px" }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "modal__close",
        attrs: {
          "data-feature": "close-modal",
          "data-target": "export-file-modal"
        }
      },
      [_c("i", { staticClass: "icon-close" })]
    )
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e14d68f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e14d68f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/BookingDetailsDocumentLandlord.vue
// module id = 759
// module chunks = 1